import type {Expand} from '../types';

import {courseExpandCommon} from '../course';
import {programExpandCommon} from '../program';
import {userExpandCommon} from '../user';

export const channelExpandCommon: Expand = {
  channel: [
    ['resource_id', null, {...courseExpandCommon, ...programExpandCommon}],
    ['user_ids->members', {name: 'User not found'}, userExpandCommon],
  ],
};
